import axios from 'axios'
import {TokenService} from "./token.services"
import {APIService} from "./api.services"
import router from '../router'
import store from '../store'
import ROLES from "../constants/roles";

const KEY_USER = 'user'

const UserService = {
    login(credentials, route) {
        axios.post(process.env.VUE_APP_API_URL + 'auth/login', credentials)
            .then(res => {
                TokenService.saveToken(res.data);
                APIService.setHeader()
                localStorage.setItem(KEY_USER, JSON.stringify(res.data.user))
                router.push(route.query.redirect || '/')
            })
            .catch(err => {
                store.commit('setUnauthorized', true);
                store.commit('setUnauthorizedMsg', err.response.data.message);
            });
    },

    logout() {
        axios.post(process.env.VUE_APP_API_URL + "auth/logout");
        TokenService.removeToken()
        APIService.removeHeader()
        localStorage.removeItem(KEY_USER)
        store.commit('setUnauthorized', false);
        store.dispatch('resetStates');
    },

    getCurrentUser() {
        return JSON.parse(localStorage.getItem(KEY_USER))
    },

    isSuperAdmin(user) {
        return user && !!user.roles.find(role => role.code === ROLES.SUPERADMIN);
    },

    isOrganizationAdmin(user) {
        return !!user.roles.find(role => role.code === ROLES.ORGANIZATION_ADMIN);
    },

    isScanningAdmin(user) {
        return !!user.roles.find(role => role.code === ROLES.SCANNING_ADMIN);
    },

    isBindezAdmin(user) {
        return !!user.roles.find(role => role.code === ROLES.BINDEZ_ADMIN);
    },

    getRoleName(roleInCode) {
        const roleInAry = roleInCode.split('_');
        let result = "";
        for (let word of roleInAry) {
            result += word.charAt(0).toUpperCase() + word.substring(1).toLowerCase() + " ";
        }
        return result.trim();
    }
}

export {UserService}
